


















import { Component, Ref, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SearchBarStore from '@/stores/search/searchBar.store';
import SearchResultStore from '@/stores/search/searchResult.store';
import Routes from '@/util/Routes';
import * as _ from 'lodash';
import { SearchUtility } from '@/stores/search/util';
import { EventKey } from '@/util/EventKey';

@Component
export default class SearchBar extends Vue {
  public search: string = '';
  private searchBarStore = getModule(SearchBarStore, this.$store);
  private searchResultStore = getModule(SearchResultStore, this.$store);
  @Ref()
  private searchBoxElement!: HTMLElement;

  get isActive() {
    return this.searchBarStore.isSearchBarActive;
  }

  public mounted(): void {
    this.$events.$on(EventKey.MAIN_CANVAS_CLICK, this.onMainCanvasClick);
  }

  public setActive() {
    this.searchBarStore.setSearchBarActive(true);
  }

  public setInactive() {
    this.searchBarStore.setSearchBarActive(false);
    this.searchBoxElement.blur();
  }

  public async updateSearchRequest() {
    const searchRequest = SearchUtility.EmptySearchRequest;
    searchRequest.queryString = this.search;
    await this.searchBarStore.updateSearchRequest(searchRequest);
  }

  public async submitSearch() {
    this.setInactive();
    const newSearchRequest = _.cloneDeep(SearchUtility.EmptySearchRequest);
    newSearchRequest.queryString = this.search;
    await this.searchResultStore.updateSearchRequest(newSearchRequest);
    await this.$router.push({
      name: Routes.ProductSearch,
      query: {query: this.search},
    });
  }

  public clearSearch() {
    this.search = '';
    this.updateSearchRequest();
  }

  private onMainCanvasClick(): void {
    if (this.isActive) {
      this.setInactive();
    }
  }
}
